// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__6-6xR","title":"AfterBackImages_title__1qhD1","images":"AfterBackImages_images__2B4Jp"};